import Footer from "../Components/AiComponents/template/Footer";
import LandingNavbar from "../Components/AiComponents/template/LandingNavbar";

type LandingLayoutProps = {
  children? : any ,
  className? : string 
}
const LandingLayout = ({children , className} : LandingLayoutProps) => {
  return (
    <div className={`w-full h-full ${className}`}>
      <div className="w-full lg:max-w-[1920px] mx-auto px-[28px] md:px-0 flex items-center flex-col">
        <LandingNavbar />
        {children}
        <Footer />
      </div>
    </div>
  );
};

export default LandingLayout;
